import { collection, onSnapshot, orderBy, query } from "firebase/firestore";
import { db } from "../../../services/firebase";
import useSWRSubscription from "swr/subscription";
import { FIRESTORE_CATEGORIES_TABLE } from "../../../constants/FirebaseConstants";

export function useCategories() {
  const { data } = useSWRSubscription("categories", (key, { next }) => {
    const q = query(
      collection(db, FIRESTORE_CATEGORIES_TABLE),
      orderBy("name"),
    );
    return onSnapshot(q, (snapshot) => {
      const data = snapshot.docs.map((doc) => {
        return { ...doc.data(), id: doc.id };
      });
      next(null, data);
    });
  });

  return {
    data,
    loading: !data,
  };
}
